module.exports = __webpack_public_path__ + "img/insurance-icon.143db212.svg";